import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  useAppContext,
  SET_INFORMATION_ALERT,
  SET_ERROR_ALERT,
  REFRESH_DATA,
} from "../../../Providers/AppProvider";
import axios from "axios";
import { Config } from "../../../Config";
import { PencilSquareIcon } from "@heroicons/react/24/solid";

// 1. upravit nazev componenty
export default function UpravaRoleZam1({ data }) {
  const { dispatch, state:{refresh} } = useAppContext();
  const [innerProps, setInnerProps] = useState({});
  const [open, setOpen] = useState(false);
  const [zamestnanci, setZamest] = useState([])

  useEffect(() => {
    setInnerProps(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (open === true) {
      axios.get(`${Config.ServerURL}/api/Dochazka/ZamestnanciZapis/1`, {
        withCredentials: true
      })
        .then(res => {
          setZamest(res.data)
        })
    }
  }, [open, refresh]);

  const cancelButtonRef = useRef(null);

  function Edit() {
    axios
    //2. upravit post
      .post(`${Config.ServerURL}/api/Dochazka/UpravaRoleZam`, innerProps, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message });
        }
        dispatch ({ type: REFRESH_DATA })
        setOpen(false);
      })
      .catch((err) => {
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message });
      });
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="dialog-transition" />
          </Transition.Child>

          <div className="fixed inset-0 z-20 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="dialog-edit-ramecek sm:max-w-4xl">
                  <div className="dialog-edit-obsah">
                  <Dialog.Title as="h3" className="dialog-edit-nadpis-velky">
                    Oprava role zaměstnance
                  </Dialog.Title>
                    <div className="grid grid-cols-6 gap-3">
                      <div className="hidden">{data.idRoleZam}</div> {/* 2.5 změnit název */}

                      {/* --- Výběr zaměstnance --- */}
                      <div className="col-span-6 sm:col-span-6">
                        <label className="dialog-edit-pole-popis">
                          Zaměstnanec
                        </label>
                        <select 
                        value={innerProps.idZam}
                        onChange={(e) =>
                          setInnerProps({
                            ...innerProps,
                            idZam: e.target.value,
                          })
                        }
                        className="admin-dialog-edit-pole-input"
                        >
                          {zamestnanci.map(z => <option key={z.idZam} value={z.idZam}>{z.prijmeni} {z.jmeno} {z.titul}</option>)}
                        </select>
                      </div>

                      {/* --- Editace Agendy ...--- */}
                      <div className="col-span-6 sm:col-span-3">
                        <label className="dialog-edit-pole-popis">
                          Agenda
                        </label>
                        <select value={innerProps.agenda} onChange={(e) => setInnerProps({...innerProps, agenda: e.target.value,})}
                          className="admin-dialog-edit-pole-input"> 
                                <option value="0">Všechny agendy</option>
                                <option value="1">Docházka</option>
                                <option value="2">Služební auta</option>
                                <option value="3">Kontakty</option>
                        </select>
                      </div>

                      {/* --- Editace Role ...--- */}
                      <div className="col-span-6 sm:col-span-3">
                        <label className="dialog-edit-pole-popis">
                          Role v agendě
                        </label>
                        <select value={innerProps.role} onChange={(e) => setInnerProps({...innerProps, role: e.target.value,})}
                          className="admin-dialog-edit-pole-input"> 
                                <option value="0">Zaměstnanec</option>
                                <option value="1">Vedoucí</option>
                                <option value="2">Tajemník</option>
                                <option value="3">Administrátor</option>
                                <option value="4">Personalista</option>
                                <option value="5">Tajemník-vedoucí</option>
                                <option value="6">Dispečer (vozidla)</option>
                        </select>
                      </div>

                      {/* Výchozí role*/}
                      <div className="col-span-6 sm:col-span-6">
                        <label className="dialog-edit-pole-popis">
                        Výchozí role ?
                        </label>
                        <input type="checkbox" checked={innerProps.vychoziRole || false}
                          onChange={(e) =>
                            setInnerProps({
                              ...innerProps,
                              vychoziRole: e.target.checked,
                            })
                          }
                          className="admin-dialog-edit-pole-checkbox"
                        ></input>
                      </div>


                    </div>
                  </div>
                  <div className="dialog-edit-zapati-pozadi">
                    <button
                      type="button"
                      className="admin-dialog-edit-tlacitko-akce"
                      onClick={() => Edit()}
                    >
                      Uložit
                    </button>
                    <button
                      type="button"
                      className="admin-dialog-edit-tlacitko-zavrit"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Zrušit
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <div
        onClick={() => setOpen(true)}
        className="admin-dialog-edit-ikona-oprava"
      >
        <span className="sr-only">Otevřit menu úprav</span>
        <PencilSquareIcon className="ikonka-velikostS" aria-hidden="true" />
      </div>
    </>
  );
}
